import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import ModalDialog from 'shared/modal/dialog';
import {
  Xdp,
  XdpMenuActionsType,
} from 'data/xdp/xdp.types';
import './xdp-action-menu.scss';

type Props = {
  selectedItem?: Xdp;
  hasPrivilegesToCreate: boolean;
  hasPrivilegeToDelete: boolean;
  onEdit: ()=> void;
  onDelete: ()=> void;
}

const XdpMenu: FunctionComponent<Props> = ({
  selectedItem,
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  onEdit,
  onDelete,
}: Props) => {

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedItem == null) {
    return null;
  }

  return (
    <div data-testid="XdpMenu" className="xdp-action-menu">
      {hasPrivilegesToCreate && (
      <Button
        className="xdp-action-menu-button"
        data-testid={`${XdpMenuActionsType.Edit}-button`}
        text={t('collectionFunction.grid.edit')}
        onClick={onEdit}
      />
      )}
      {hasPrivilegeToDelete && (
      <Button
        className="xdp-action-menu-button"
        data-testid={`${XdpMenuActionsType.Delete}-button`}
        text={t('collectionFunction.grid.delete')}
        onClick={handleOpenDeleteDialog}
      />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('xdp.delete.success')}
        displayMessage={
          t('collectionFunction.deletePopup.message', { name: selectedItem.ipduId })
        }
        actionText={t('collectionFunction.deletePopup.action')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default XdpMenu;
